module.exports = __webpack_public_path__ + "img/closeImg.8e4e6fa9.jpg";